export default __webpack_public_path__ + "static/media/loupe.f4e852a1.svg";